<div class="tp-wrap">
  <h3 class="tp-heading" *ngIf="heading">{{ heading }}</h3>

  <div class="theme-palette">
    <!-- Theme picker: a labelled native select, mirroring the "Pick a Color" inputs
         in the other widgets. -->
    <div class="tp-head">
      <label class="tp-label" for="tp-theme">Pick A Theme</label>
      <app-cg-select [options]="themeOptions" [value]="selectedKey"
                     (valueChange)="onSelect( $event )"
                     ariaLabel="Pick a Codigrate theme"></app-cg-select>
    </div>

    <!-- The theme's ten colours as one tidy row of squares, the hex code under
         each; click to copy. -->
    <div class="tp-swatches">
      <div class="tp-swatch-cell" *ngFor="let c of colors">
        <button type="button" class="tp-swatch" [style.background]="c"
                (click)="copy( c )" [attr.aria-label]="'Copy ' + c"></button>
        <span class="tp-swatch-hex">{{ copiedHex === c ? 'Copied' : c }}</span>
      </div>
    </div>

    <div class="tp-bottom">
      <a class="tp-open codigrate-button" [href]="paletteUrl" target="_blank" rel="noopener">
        Open In Palette Tool
      </a>
    </div>
  </div>
</div>
